import { NodeIndexOutlined } from "@ant-design/icons";
import { pluralize } from "src/utils/strings";
import { useApplicationContext } from "src/hooks/useApplication";
import { durationReadable } from "src/utils/date";
import { useEntityContext } from "../useEntityContext";
import { Flow } from "../overviews/Flow";
import { EntityScreen } from "./components/layout/Screen";
import { HeaderPanel } from "./components/layout/HeaderPanel";
import { ActionCard } from "./components/ActionCard";
import { MetricTag } from "./components/Tags";
import { SummaryPanel } from "./components/layout/SummaryPanel";
import { InsightsPanel } from "./components/layout/InsightsPanel";
import { toHeaderAttributes } from "./components/HeaderAttributes";
import { ProgressMetric } from "./components/ProgressMetric";
import { EntityTabs } from "./components/EntityTabs";

export const FlowEntity = () => {
  const orgId = useApplicationContext().org_id!;
  const context = useEntityContext();
  const properties = context.dataRef.current.entity.properties;
  const entityType = context.dataRef.current.entity.labels[0];

  return (
    <EntityScreen
      headerPanel={
        <HeaderPanel
          label={properties.name}
          entity={context.dataRef.current.entity}
          attributes={toHeaderAttributes({
            orgId,
            context,
            entityType,
            attributes: [
              {
                name: "time",
                text: durationReadable(properties.workingTime, "minutes"),
              },
              {
                name: "focus",
                text: durationReadable(properties.focusTime, "minutes"),
              },
              {
                name: "disrupt",
                text: durationReadable(properties.disruptedTime, "minutes"),
              },
            ],
          })}
          icon={<NodeIndexOutlined style={{ fontSize: 40 }} />}
        />
      }
      summaryPanel={
        <SummaryPanel
          title={`${properties.name} for ${properties.Person.value}`}
          description={properties.description || properties.title}
        />
      }
      insightsPanel={
        <InsightsPanel
          cards={[
            <ActionCard
              key="meetings"
              badge={<MetricTag />}
              label="Meetings count"
              value={
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 18, fontWeight: 600 }}>
                    {properties.meetingsCount}
                  </div>
                  {pluralize("meeting", properties.meetingsCount)}
                </div>
              }
            />,
            <ActionCard
              key="messages"
              badge={<MetricTag />}
              label="Message count"
              value={
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 18, fontWeight: 600 }}>
                    {properties.messagesCount}
                  </div>
                  {pluralize("message", properties.messagesCount)}
                </div>
              }
            />,
            <ActionCard
              key="focus-time"
              badge={<MetricTag />}
              label="Focus time"
              value={
                <ProgressMetric
                  higherBetter
                  isPercent
                  value={(properties.focusTimePercent * 100).toFixed(1)}
                  data={undefined}
                />
              }
            />,
            <ActionCard
              key="disrupted-time"
              badge={<MetricTag />}
              label="Disrupted time"
              value={
                <ProgressMetric
                  lowerBetter
                  isPercent
                  value={(properties.disruptedTimePercent * 100).toFixed(1)}
                  data={undefined}
                />
              }
            />,
          ]}
        />
      }
    >
      <EntityTabs
        entity={context.dataRef.current.entity}
        propertiesSkipList={[
          "name",
          "workingTime",
          "focusTime",
          "disruptedTime",
          "description",
          "meetingsCount",
          "messagesCount",
          "focusTimePercent",
          "Day",
          "DayOfWeek",
          "DayOfMonth",
          "MinuteTrunc",
          "HourTrunc",
          "DayTrunc",
          "Hour",
          "Minute",
          "Month",
          "Quarter",
          "Week",
          "Year",
        ]}
        tabs={[
          {
            id: "flow",
            key: "flow",
            label: "Flow",
            children: <Flow entity={context.dataRef.current.entity} />,
          },
          // {
          //   id: "insights",
          //   key: "insights",
          //   label: "Insights",
          //   children: <Insights entity={context.dataRef.current.entity} />,
          // },
          // {
          //   id: "history",
          //   key: "history",
          //   label: "History",
          //   children: (
          //     <History>
          //       <HistoryComponent />
          //     </History>
          //   ),
          // },
        ]}
      />
    </EntityScreen>
  );
};
